'use client';

import LegalCards from '@components/LegalCards';
import PageHeader from '@components/layout/page-header';
import { useTranslations } from 'next-intl';
import { FC } from 'react';

const Legal: FC = () => {
  const t = useTranslations();

  return (
    /* No @container/chrome ancestor on public routes, so the title must not
       be gated on a container query it will never satisfy. The legal layout
       already supplies the narrow container. */
    <>
      <PageHeader title={t('navigation.legal')} showTitle="always" />
      <LegalCards />
    </>
  );
};

export default Legal;
